/**
 * All supported icon color names.
 */
export const ICON_COLORS = [
  "body",
  "black",
  "white",
  "darkblue",
  "turquoise",
  "lightgrey",
  "red",
  "green",
  "orange",
  "darkgreen",
  "darkgrey",
  "purple",
] as const;

/**
 * The icon color.
 */
export type IconColor = (typeof ICON_COLORS)[number];
